import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React__default from 'react';
import styled, { withTheme } from 'styled-components';
import '../text/text.component.js';
import Action from '../actions/action.component.js';
import '../../theme/theme-style.js';
import '../../App.css.js';
import '../../theme/text-theme.js';
import '../media/Img.js';
import '../media/Icon.js';
import { t } from '../../utils/utils.js';
var _excluded = ["items_list", "style", "theme", "isMobile", "lng"];
var Container = styled.div.withConfig({
  displayName: "view-more-listcomponent__Container",
  componentId: "sc-3w0zw5-0"
})(["display:flex;flex-direction:column;align-items:start;box-sizing:border-box;"]);
var printItems = function printItems(items_list, items_to_show) {
  var list = [];
  if (items_list && items_list.length > items_to_show) {
    for (var i = 0; i < items_to_show; i++) {
      list.push(items_list[i]);
    }
  } else {
    return items_list;
  }
  return list;
};
var ViewMoreList = function ViewMoreList(_ref) {
  var items_list = _ref.items_list,
    style = _ref.style;
  _ref.theme;
  _ref.isMobile;
  var lng = _ref.lng,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _React$useState = React__default.useState(10),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    itemsToShow = _React$useState2[0],
    setItemsToShow = _React$useState2[1];
  var showBtn = items_list && items_list.length > itemsToShow;
  return /*#__PURE__*/React__default.createElement(Container, _extends({
    style: style
  }, rest), printItems(items_list, itemsToShow), /*#__PURE__*/React__default.createElement(Action, {
    linkText: t(lng, "view_more.btn"),
    color: "green",
    active: true,
    linkIcon: "chevron_down",
    onClick: function onClick() {
      setItemsToShow(itemsToShow + 10);
    },
    moveIcon: false,
    style: {
      marginTop: "24px",
      display: showBtn ? "" : "none"
    }
  }));
};
var viewMoreList_component = withTheme(ViewMoreList);
export { viewMoreList_component as default };